import React from "react";
import Section from "./section";
import { IParentSize, IRealtimeData } from "../../../../types";
import AcquisitionChartWrapper from "../../../dashboardRT/components/widgets/chart/acquisitionChartWrapper";
import { DashboardSchemaType, IAcquisitionDataSchema } from "../../../interruptions/types";
import { IDashboard } from "../../../dashboardRT/types";

interface IProps {
  parentSize: IParentSize;
  realtime:  Record<string, IRealtimeData>;
}

const schemas: Record<string, IAcquisitionDataSchema> = {
  [DashboardSchemaType.Acquisition]: {
    variables: {},
    events: {}
  }
};

const dashboard: IDashboard = {
  dashboardID: null,
  moduleID: 2,
  nodeType: "",
  nodeID: 0,
  name: "",
  layout: {
    components:[
      {
        key: "ld4n9enfycyo2o8ic4",
        title: "Variables",
        componentType: 1,
        column: 1,
        row: 1,
        columnSpan: 1,
        rowSpan: 1,
        config: {
          acquisitionCell: {
            key: "ld4n9io2v50wiak3e7o",
            module: 2,
            title: "Name",
            machine: "EAF",
            variables: [
              {
                hash: "ld4nadw96zh1jnfwl4c",
                field: "MS.CASTER1.TURRET.ARM_IN_CAST_WEIGHT",
                title: "ARM_IN_CAST_WEIGHT",
                color: "#FF1493",
                unit: "s ton",
                decimals: 2,
                limits: [],
                annotations: [],
                yAxis: {
                  name: "WEIGHT",
                  minimum: 0,
                  maximum: 140,
                  ticksCount: 5
                }
              },
              {
                hash: "ld4nadw93zh1jnfwl4c",
                field: "MS.CASTER1.TUNDISH.NET_WEIGHT",
                title: "NET_WEIGHT",
                color: "#FFFFFF",
                unit: "s ton",
                decimals: 2,
                limits: [],
                annotations: [],
                yAxis: {
                  name: "WEIGHT",
                  minimum: 0,
                  maximum: 140,
                  ticksCount: 5
                }
              },
              {
                hash: "ld4nadw90zh1jnfwl4c",
                field: "MS.CASTER1.TUNDISH.STEEL_TEMPERATURE",
                title: "STEEL_TEMPERATURE",
                color: "#00F811",
                unit: "°F",
                decimals: 2,
                limits: [],
                annotations: [],
                yAxis: {
                  name: "TEMPERATURE",
                  minimum: 2200,
                  maximum: 3000,
                  ticksCount: 5
                }
              },
              {
                hash: "ld4nadw97zh1jnfwl4c",
                field: "MS.CASTER1.QA.N2.SUPER_HEAT_LIQUIDUS_TEMPERATURE",
                title: "SUPER_HEAT_LIQUIDUS_TEMPERATURE",
                color: "#00f7f7",
                unit: "°F",
                decimals: 2,
                limits: [],
                annotations: [],
                yAxis: {
                  name: "TEMPERATURE",
                  minimum: 2200,
                  maximum: 3000,
                  ticksCount: 5
                }
              },
              {
                hash: "ld4nadw94zh1jnfwl4c",
                field: "MS.CASTER1.AUTO_SUPER_HEAT",
                title: "AUTO_SUPER_HEAT",
                color: "#ffFF00",
                unit: "",
                decimals: 2,
                limits: [],
                annotations: [],
                yAxis: {
                  name: "SUPER HEAT",
                  minimum: 20,
                  maximum: 90,
                  ticksCount: 5
                }
              },
              {
                hash: "ld4nadw91zh1jnfwl4c",
                field: "MS.CASTER1.N2.SUPER_HEAT_MAX",
                title: "SUPER_HEAT_MAX",
                color: "#FF0000",
                unit: "°F",
                decimals: 2,
                limits: [],
                annotations: [],
                yAxis: {
                  name: "SUPER HEAT",
                  minimum: 20,
                  maximum: 90,
                  ticksCount: 5
                }
              },
              {
                hash: "ld4nadw98zh1jnfwl4c",
                field: "MS.CASTER1.N2.SUPER_HEAT_MIN",
                title: "SUPER_HEAT_MIN",
                color: "#FF0000",
                unit: "°F",
                decimals: 2,
                limits: [],
                annotations: [],
                yAxis: {
                  name: "SUPER HEAT",
                  minimum: 20,
                  maximum: 90,
                  ticksCount: 5
                }
              },
              {
                hash: "ld4nadw95zh1jnfwl4c",
                field: "MS.CASTER1.N2.SUPER_HEAT_AIM",
                title: "SUPER_HEAT_AIM",
                color: "#FFF89A",
                unit: "°F",
                decimals: 2,
                limits: [],
                annotations: [],
                yAxis: {
                  name: "SUPER HEAT",
                  minimum: 20,
                  maximum: 90,
                  ticksCount: 5
                }
              }
            ],
            events: []
          }
        }
      }
    ],
    palette:{

    }
  },
  userID: 0,
  owner: null,
  isPrivate: true,
  isDefault: false,
  isAcquisition: true,
  customConfig: {
    range: 6,
    fontSize: 1,
    scan: 2000
  },
  rtModule: true
};


const SuperHeat = ({ realtime, parentSize }: IProps) => {

  return (
    <Section title="Super Heat" level={0} style={{ gridColumn: "2/4" }}>
      <AcquisitionChartWrapper
        realtime={realtime}
        component={dashboard.layout.components[0]}
        dashboard={dashboard}
        runtime={true}
        parentSize={parentSize}
        setDashboard={() => {}}
        schemas={schemas}/>
    </Section>
  );
}

export default SuperHeat;